export const black0 = `rgba(0, 0, 0, 0.0)`
export const white0 = `rgba(255, 255, 255, 0.0)`
export const black10 = `rgba(0, 0, 0, 0.1)`
export const white10 = `rgba(255, 255, 255, 0.1)`
export const black20 = `rgba(0, 0, 0, 0.2)`
export const white20 = `rgba(255, 255, 255, 0.2)`
export const black30 = `rgba(0, 0, 0, 0.3)`
export const white30 = `rgba(255, 255, 255, 0.3)`
export const black40 = `rgba(0, 0, 0, 0.4)`
export const white40 = `rgba(255, 255, 255, 0.4)`
export const black50 = `rgba(0, 0, 0, 0.5)`
export const white50 = `rgba(255, 255, 255, 0.5)`
export const black60 = `rgba(0, 0, 0, 0.6)`
export const white60 = `rgba(255, 255, 255, 0.6)`
export const black70 = `rgba(0, 0, 0, 0.7)`
export const white70 = `rgba(255, 255, 255, 0.7)`
export const black80 = `rgba(0, 0, 0, 0.8)`
export const white80 = `rgba(255, 255, 255, 0.8)`
export const black90 = `rgba(0, 0, 0, 0.9)`
export const white90 = `rgba(255, 255, 255, 0.9)`
export const black100 = `rgba(0, 0, 0, 1.0)`
export const white100 = `rgba(255, 255, 255, 1.0)`
export const primary = `#5e4df0`
export const secondary = `#3a2f6d`
export const cardsBackground = `#2d2552`
export const backgroundDark = `#17132c`
export const backgroundLight = `#221b40`
export const textWhite = `#ffffff`
export const textLight = `#d5ceff`
export const textMedium = `#9b96bb`
export const textDark = `#7d7899`
export const pink = `#dc6488`
export const blue = `#3a84ef`
export const darkBlue = `#4c66f3`
export const lightPurple = `#9c3dff`
export const yellow = `#fcd23c`
export const bottomBarText = `#665d9e`
export const primaryGradient = `linear-gradient(180deg, #6877ff 0%,#5e4df0 100%)`
export const primary2Gradient = `linear-gradient(180deg, #5b4aee 0%,#5c7ef8 100%)`
export const shadowCards = `#d9d9d9`
export const shadowSmallItems = `#d9d9d9`
export const seconderyGradient = `linear-gradient(180deg, #b499ff 0%,#7c99ff 48.4375%)`
export const backgroundRadialGradientGradient = `radial-gradient(#292052 0%,#17132c 100%)`
export const backgroundMedium = `#1f193c`

const colors = {
  black0,
  white0,
  black10,
  white10,
  black20,
  white20,
  black30,
  white30,
  black40,
  white40,
  black50,
  white50,
  black60,
  white60,
  black70,
  white70,
  black80,
  white80,
  black90,
  white90,
  black100,
  white100,
  primary,
  secondary,
  cardsBackground,
  backgroundDark,
  backgroundLight,
  textWhite,
  textLight,
  textMedium,
  textDark,
  pink,
  blue,
  darkBlue,
  lightPurple,
  yellow,
  bottomBarText,
  primaryGradient,
  primary2Gradient,
  shadowCards,
  shadowSmallItems,
  seconderyGradient,
  backgroundRadialGradientGradient,
  backgroundMedium
}
export default colors